/**
 * Split a buffer into chunks of a maximum length.
 */
export function chunkUint8Array(buffer: Uint8Array, maxLength: number): Uint8Array[] {
    const chunks: Uint8Array[] = [];
    let offset = 0;
    while (offset < buffer.length) {
        chunks.push(buffer.slice(offset, offset + maxLength));
        offset += maxLength;
    }
    return chunks;
}

/**
 * Merge a list of buffers into a single buffer.
 */
export function mergeUint8Arrays(buffers: Uint8Array[]): Uint8Array {
    const length = buffers.reduce((total, buffer) => total + buffer.length, 0);
    const merged = new Uint8Array(length);
    let offset = 0;
    buffers.forEach((buffer) => {
        merged.set(buffer, offset);
        offset += buffer.length;
    });
    return merged;
}
